import { render, staticRenderFns } from "./BookingPriceTip.vue?vue&type=template&id=136150a7&scoped=true"
import script from "./BookingPriceTip.vue?vue&type=script&lang=js"
export * from "./BookingPriceTip.vue?vue&type=script&lang=js"
import style0 from "./BookingPriceTip.vue?vue&type=style&index=0&id=136150a7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136150a7",
  null
  
)

export default component.exports